/**
 * @description 项目基础路由(静态路由)
 */

// 未匹配路由 重定向
export const NotMatchRouter = { path: '*', redirect: '/404', hidden: true }

export const LoginRouter = { path: '/login', name: 'login', component: () => import('@/views/login/login'), hidden: true, meta: { title: '登录' } }

export const SystemError = { path: '/500', name: '500', component: () => import('@/views/common/500'), hidden: true }

export const NoAccess = { path: '/403', name: '403', component: () => import('@/views/common/403'), hidden: true }

export const NotFound = { path: '/404', name: '404', component: () => import('@/views/common/404'), hidden: true }



export default [
  NotFound,
  SystemError,
  NoAccess,
  LoginRouter,
  NotMatchRouter,
]



// WEBPACK FOOTER //
// ./src/router/base.router.js